import React, { useState } from "react";
import { Drawer } from "antd";
import "./SidebarLayout.css";
import AssetManagement from "../AssetManagementPage/AssetManagement";

const menuItems = [
  { key: "dashboard", label: "Dashboard", icon: "/Dashboard_icon.svg" },
  { key: "asset", label: "Asset Management", icon: "/Asset_Management_icon.svg" },
  { key: "lifecycle", label: "Asset Lifecycle Management", icon: "/Lifecycle_icon.svg" },
  { key: "stock", label: "Stock Management", icon: "/Stock_Management_icon.svg" },
];

const SidebarLayout = ({ children }) => {
  const [activeTab, setActiveTab] = useState("asset");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const handleMenuClick = (key) => {
    setActiveTab(key);
    if (window.innerWidth <= 767) {
      setSidebarOpen(false); // Close drawer on mobile after selection
    }
  };

  // Desktop Sidebar Content
  const SidebarContent = ({ isMobile = false }) => (
    <div className={`sidebar-content ${collapsed && !isMobile ? "collapsed" : ""}`}>
      {/* Logo */}
      <div className="logo-container">
        {(!collapsed || isMobile) && (
          <img src="/amiand-logo.svg" alt="Logo" className="logo-img" />
        )}
        {!isMobile && (
          <button className="collapse-btn" onClick={toggleCollapse}>
            <img 
              src="/above_back.svg" 
              alt="Collapse" 
              className={`collapse-icon ${collapsed ? "rotated" : ""}`}
            />
          </button>
        )}
      </div>
      <div className="separator"></div>

      {/* Menu */}
      <ul className="menu-list">
        {menuItems.map((item) => (
          <li
            key={item.key}
            onClick={() => handleMenuClick(item.key)}
            className={`menu-item ${activeTab === item.key ? "active" : ""} ${collapsed && !isMobile ? "collapsed-item" : ""}`}
            title={collapsed && !isMobile ? item.label : ""}
          >
            <img
              src={item.icon}
              alt={`${item.label} icon`}
              className={`menu-icon-left ${activeTab === item.key ? "white-icon" : ""}`}
            />
            {(!collapsed || isMobile) && (
              <span className="menu-label">{item.label}</span>
            )}
          </li>
        ))}
      </ul>

      {/* User Box */}
      <div className={`user-box ${collapsed && !isMobile ? "collapsed-user" : ""}`}>
        <div className="user-initials">SM</div>
        {(!collapsed || isMobile) && (
          <>
            <div className="user-details">
              <div className="user-name">Sayli M.</div>
              <div className="user-email">saylim123@gmail.com</div>
            </div>
            <img src="/logout_back.svg" alt="Logout" className="logout-icon" />
          </>
        )}
      </div>
    </div>
  );

  return (
    <div className="layout-container">
      {/* Mobile Menu Button */}
      <button className="mobile-menu-btn" onClick={toggleSidebar}>
        <img src="/above_back.svg" alt="Menu" />
      </button>

      {/* Desktop Sidebar */}
      <div className={`desktop-sidebar ${collapsed ? "collapsed" : ""}`}>
        <SidebarContent />
      </div>

      {/* Mobile Drawer */}
      <Drawer
        title={null}
        placement="left"
        onClose={toggleSidebar}
        open={sidebarOpen}
        bodyStyle={{ padding: 0 }}
        headerStyle={{ display: 'none' }}
        width="85vw"
        className="mobile-drawer"
        maskClosable={true}
      >
        <SidebarContent isMobile={true} />
      </Drawer>

      {/* Content */}
      <div className={`main-content ${collapsed ? "collapsed-content" : ""}`}>
        {activeTab === "asset" ? <AssetManagement /> : children || <div>Select a tab to view content</div>}
      </div>
    </div>
  );
};

export default SidebarLayout;